import React from 'react';
import { Card, Table, Spinner, Alert, Badge } from 'react-bootstrap';

const TeacherTimeTableView = ({ data, allPeriods }) => {
  const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday','Saturday'];

  const getPeriodTypeVariant = (type) => {
    switch (type) {
      case 'break': return 'success';
      case 'assembly': return 'warning';
      case 'period': return 'primary';
      default: return 'secondary';
    }
  };

  const sortedPeriods = [...allPeriods].sort((a, b) => a.sequence_order - b.sequence_order);

  // Create a lookup map for quick access
  const timetableMap = {};
  data.forEach(entry => {
    if (!timetableMap[entry.day]) {
      timetableMap[entry.day] = {};
    }
    timetableMap[entry.day][entry.period_id] = entry;
  });

  const renderTimetableMatrix = () => (
    <Table bordered responsive className="mt-4">
      <thead className="table-secondary text-center">
        <tr>
          <th>Day / Period</th>
          {sortedPeriods.map((period) => (
            <th key={period.period_id}>
              <div className="d-flex flex-column align-items-center">
                <Badge bg={getPeriodTypeVariant(period.period_type)} className="mb-1">
                  {period.period_name}
                </Badge>
                <div className="text-muted small">
                  {period.start_time} - {period.end_time}
                </div>
              </div>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {days.map(day => (
          <tr key={day}>
            <td className="fw-semibold align-middle">{day}</td>
            {sortedPeriods.map(period => {
              const slot = timetableMap[day]?.[period.period_id];
              const isNonPeriod = period.period_type !== 'period';

              return (
                <td
                  key={`${day}-${period.period_id}`}
                  className={`text-center align-middle ${isNonPeriod ? `table-${getPeriodTypeVariant(period.period_type)}` : ''}`}
                >
                  {isNonPeriod ? (
                    <div className="fw-semibold">{period.period_name}</div>
                  ) : slot ? (
                    <>
                      <div className="fw-semibold">{slot.subject_name}</div>
                      <div className="text-muted small">{slot.class_name} {slot.section_name}</div>
                    </>
                  ) : (
                    <div className="text-muted">Free</div>
                  )}
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </Table>
  );

  return (
    <Card className="mt-3">
      <Card.Header>
        <h5 className="mb-0">Teacher Timetable</h5>
      </Card.Header>
      <Card.Body>
        {!data || data.length === 0 ? (
          <div className="text-center py-4">
            <Spinner animation="border" variant="primary" />
            <p className="mt-2">Loading timetable...</p>
          </div>
        ) : (
          renderTimetableMatrix()
        )}
      </Card.Body>
    </Card>
  );
};

export default TeacherTimeTableView;
